// ##### Komarov 2025-07-22
import React from 'react';
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import LargeScreenTopHotelsDiv from './LargeScreenTopHotelsDiv';

// ##### Komarov 2025-07-22
const LargeScreenTopHotels = ({ TopHotelContents, GetHotelDetails }) => {
  return (
    <>
      {/* ##### 23-11-08 Komarov */}
      <Media at="Tablet-768-1024">
        <LargeScreenTopHotelsDiv width={1180} TopHotelContents={TopHotelContents} GetHotelDetails={GetHotelDetails} />
      </Media>
      <Media greaterThan="Tablet-768-1024">
        <LargeScreenTopHotelsDiv width={1280} TopHotelContents={TopHotelContents} GetHotelDetails={GetHotelDetails} />
      </Media>
    </>
  );
}; // ##### 23-10-10 Komarov

export default LargeScreenTopHotels;
